import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import TableSortLabel from "@mui/material/TableSortLabel";
import TableRow from "@mui/material/TableRow";
import { visuallyHidden } from "@mui/utils";
import CheckBoxCustom from "../checkbox";

const EnhancedTableHead = (props) => {
  const { order, 
    orderBy, 
    rowCount, 
    numSelected,
    tableHeadings,
    tabelCellStyles,
    onRequestSort, 
    selectedHeaders = [], 
    onSelectAllClick,
    selectable=false } = props;

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {
          selectable && <TableCell padding="checkbox">
          <CheckBoxCustom 
            indeterminate={numSelected > 0 && numSelected < rowCount}
            value={rowCount > 0 && numSelected === rowCount} 
            handleChange={onSelectAllClick} 
          />
        </TableCell>}
        {selectedHeaders.map((headCell) => (
          <TableCell
            key={headCell.id}
            style={tabelCellStyles[headCell.id]}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {tableHeadings[headCell.id]}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

export default EnhancedTableHead;